import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import DefaultLayout from '../components/molecules/common/DefaultLayout'
import Text from '../components/atoms/Text'
import { logout } from '../api/auth'
import { useNavigate } from 'react-router-dom'
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import { getRegisterInfo } from '../api/mypage'
import { useBack } from '../hooks/useBack'
import ChannelService from '../ChannelService'
import { logEvent } from '../utils/eventLogger'

const Wrapper = styled.div`
  width: 100%;
  text-align: left;
  hr {
    border-top: 1px solid ${(props) => props.theme.colors.neutral[200]};
    margin-top: 10px;
  }
`
const Category = styled(Text)`
  display: inline-block;
  padding: 0 20px;
  margin: 24px 0 8px 0;
`
const Menu = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
`
const ArrowIcon = styled(ArrowForwardIosOutlinedIcon)`
  color: ${(props) => props.theme.colors.text.alternative};
`

const MyPage = () => {
  const [isChildRegistered, setIsChildRegistered] = useState(false);

  useEffect(() => {
    const fetchRegisterInfo = async() => {
      try {
        const rlt = await getRegisterInfo();
        // console.log(rlt)
        setIsChildRegistered(!!rlt?.isChildRegistered)
      } catch (err) {
        console.log(err)
      }
    }
    fetchRegisterInfo();
  }, [])

  const navigate = useNavigate();
  const goBack = useBack(); // 뒤로가기 훅 호출
  
  const handleAction = async (item) => {
    if (item.action === 'logout') {
      try {
        // 채널톡 서비스 종료
        ChannelService.resetPage();
        ChannelService.shutdown();
        ChannelService.clearChannelCookies();
        await logout();
        window.location.href = '/login';
      } catch (err) {
        console.error('로그아웃 실패', err);
      }
    }
  };

  const handleMenuClick = (item) => {
    if (item.checkChild && !isChildRegistered) {
      alert('아이를 먼저 등록해주세요.');
      return;
    }

    if (item.checkAlreadyRegistered && isChildRegistered) {
      alert('이미 아이가 등록되어 있어요.');
      return;
    }

    if (item.event) {
      logEvent(item.event)
    }

    const actionMap = {
      internal: () => navigate(item.url),
      external: () => window.open(item.url, '_blank', 'noopener'),
      action: () => handleAction(item)
    };

    actionMap[item.type]?.();
  };

  const sections = [
    {
      title: "아이관리",
      menus: [
        { label: '아이 등록', type: 'internal', url: '/mypage/child-register', checkAlreadyRegistered: true, event: "children_register_start" },
        { label: '아이 음성 등록', type: 'internal', url: '/mypage/voice-register', checkChild: true, event: "voice_embedding_start" }
      ]
    },
    {
      title: "서비스",
      menus: [
        { label: '사용 가이드', type: 'internal', url: '/mypage/tutorials' },
        { label: '공지사항', type: 'external', url: 'https://slashpage.com/tickle-talk/qpv5x4277pv542kyn3dw' },
        { label: 'FAQ', type: 'external', url: 'https://slashpage.com/tickle-talk/7vgjr4m1qw97wmdwpy86' },
        { label: '오류 제보', type: 'external', url: 'https://slashpage.com/tickle-talk/qrx6zk258g1grmv314y5' },
        { label: '기능 제안', type: 'external', url: 'https://slashpage.com/tickle-talk/ywk9j72976y6v2gpqvnd' },
        { label: '이용약관', type: 'external', url: 'https://slashpage.com/tickle-talk/1q3vdn2px86zx2xy49pr' },
      ]
    },
    {
      title: "기타",
      menus: [
        { label: '로그아웃', type: 'action', action: 'logout' }
      ]
    }
  ];

  return (
    <DefaultLayout
      headerType="sub"
      title="마이페이지"
      onBack={() => navigate('/')}
      hasNavBar={false}>
      <Wrapper>
        {sections.map((section, idx) => (
          <div key={section.title}>
            <Category variant="body2" color="assistive" weight="medium">
              {section.title}
            </Category>
            {section.menus.map((menu) => (
              <div key={menu.label}>
                <Menu onClick={() => handleMenuClick(menu)}>
                  <Text weight="regular">{menu.label}</Text>
                  <ArrowIcon sx={{ fontSize: 18 }} />
                </Menu>
              </div>
            ))}
            {idx !== sections.length - 1 && <hr />}
          </div>
        ))}
      </Wrapper>
    </DefaultLayout>
  )
}

export default MyPage